import OnboardingFlowConfigContext from './OnboardingFlowConfigContext';
import OnboardingFlowConfigContextProvider from './OnboardingFlowConfigContextProvider';

export default OnboardingFlowConfigContext;

export * from './withOnboardingFlowConfigContext';
export {
  OnboardingFlowConfigContextProvider,
};
